const AUTHENTICATION_VARIRABLES = {
    USER_IDLE_TIMEOUT_MINUTES: 1440 //24 hours
};

module.exports = { AUTHENTICATION_VARIRABLES };